import React, { useState, useEffect, useRef } from 'react';

import api from "../../../services/api";
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { Button } from 'react-bootstrap'
import TokenService from "../../../services/token.service";

// Global connection version counter to persist across component remounts
let globalConnectionVersion = 0;

export function EcgWebSocketReceiver({ realtimeDataUrl, receiveNewDataCallback, finalizeCallback, timeViewMode, onCommentUpdate }) {

  const [webSocketTryAgain, setWebSocketTryAgain] = useState(false);
  const webSocket = useRef(null);
  const connectionVersionRef = useRef(0);

  useEffect(() => {    
    if (realtimeDataUrl) {
      // Increment global version when creating new connection
      globalConnectionVersion += 1;
      connectionVersionRef.current = globalConnectionVersion;
      //console.log('clog: Creating WebSocket connection version:', connectionVersionRef.current);
      webSocket.current = createWebSocketConnection(realtimeDataUrl, timeViewMode, connectionVersionRef.current);            
    }

    return () => {
      if (webSocket.current) {
        webSocket.current.close();
        console.log("clog: Closing WebSocket connection");
      }
    };

  }, [webSocketTryAgain, timeViewMode]);


  const createWebSocketConnection = function (webSocketUrl, timeViewMode, connectionVersion) {
    //console.log('clog: Creating WebSocket with timeViewMode:', timeViewMode, 'version:', connectionVersion);
    let url = new URL(webSocketUrl, window.location.href);
    url.protocol = 'wss';
    
    // Map frontend timeViewMode to backend DataDisplayTypes
    // Frontend: 0 = from zero, 1 = actual time (from DropdownDisplayTime)
    // Backend: 0 = StartFromBeginning, 1 = AbsoluteTime
    if (timeViewMode !== undefined && timeViewMode !== null) {
      url.searchParams.set('displayType', timeViewMode);
    }
    
    let authToken = TokenService.getLocalAccessToken();

    let ws = new WebSocket(url.href, [authToken]);
    ws.onopen = function () {
      sendConfirmationDataReceived(ws, 0);
    };

    // Store the connection version for this specific WebSocket
    ws.connectionVersion = connectionVersion;
    
    ws.onmessage = function (event) {
      // Check if this data is from the current connection version
      if (ws.connectionVersion !== connectionVersionRef.current) {
        //console.log('clog: Ignoring data from old WebSocket connection', {
        //  dataVersion: ws.connectionVersion,
        //  currentVersion: connectionVersionRef.current
        //});
        return;
      }
      
      const json = JSON.parse(event.data);
      try {        
        //console.log(json?.multilineData?.processed);
        if (json.type === "commentUpdate") {
          // Handle comment update with array of comments
          if (onCommentUpdate) {
            onCommentUpdate(json.comments);
          }
        } else {
          if ((json.type === "data")) {
            if (json.isLastMessage) {
              //console.log('clog: Received last message, finalizing');
              finalize();
            } else if (json.multilineData) {
              // Regular data with charts and initial processed data
              if (receiveNewDataCallback) receiveNewDataCallback(json.multilineData);
              sendConfirmationDataReceived(ws, json.msgId);
            } else if (json.processedDataUpdate) {
              // Processed data update only
              if (receiveNewDataCallback) {
                receiveNewDataCallback({
                  processed: json.processedDataUpdate,
                  processedOnly: true
                });
              }
            }
          } else {
            console.error('Unknown message type from server', json.type);
          }
        }                       
      } catch (err) {
        console.log('clog: WebSocket message error:', err);
      }
    };

    ws.onerror = function (event) {
      console.log(event);
    };

    ws.onclose = function (event) {
      console.log(event);
      if (event.code === 1008 && event.reason === 'Unauthorized') {
        api
          .post('/auth/ok')
          .then(() => {
            setWebSocketTryAgain(true);
          });
      }
    };

    return ws;
  };

  const sendConfirmationDataReceived = function (ws, msgId) {
    //console.log('Confirming ', msgId);
    ws.send(JSON.stringify({ msgId: msgId }));
  };

  const finalize = function () {
    if (finalizeCallback) finalizeCallback();
  };

  return (
    <>
     
    </>
  )
}